import { useEffect } from 'react';

import { useLoginToFirebase } from './useLoginToFirebase';

import {
    useAuthentication,
    useStartUpdateUserActivity,
    useWatchForConversationsStatus,
} from '@speeki/firebase-chat';

import { useReactiveVar } from '@apollo/client';
import { authVar } from '@boot/reactiveVariables';

export const useChatRootSetup = () => {
    const { loginToFirebase, signOut } = useLoginToFirebase();
    const auth = useReactiveVar(authVar);

    // TODO: test for logged in user
    useEffect(() => {
        auth.isLoggedIn && !auth.isGuest ? loginToFirebase() : signOut();
    }, [auth]);

    const { useWatchForAuthStateChange } = useAuthentication();

    useWatchForAuthStateChange();
    useStartUpdateUserActivity();
    useWatchForConversationsStatus();
};
